import axios from "axios";
import { BASE_URL, OPEN_API_BASE_URL } from "../app/config";

export const Api = axios.create({
  baseURL: BASE_URL,
});

export const OpenApi = axios.create({
  baseURL: OPEN_API_BASE_URL,
});

OpenApi.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message ?? 'Có lỗi xảy ra, vui lòng thử lại sau');
    }

    throw error;
  }
);

